import React from "react"
import { Helmet } from "react-helmet"
import { useLocation } from "react-router-dom"

import { getSeo, siteUrl, siteName, defaultImage } from "../../data/Seo"

const Head = ({ title }) => {
  const { pathname } = useLocation()
  const seo = getSeo(pathname)
  const fullTitle = `${seo.title || title} | ${siteName}`
  const url = `${siteUrl}${pathname}`

  return (
    <Helmet>
      <html lang="pl" />
      <title>{fullTitle}</title>
      <meta name="description" content={seo.description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={defaultImage} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={seo.description} />
      {!seo.title && <meta name="robots" content="noindex, follow" />}
    </Helmet>
  )
}

export default Head
